import React, { useState, useEffect, useRef } from 'react';
import './Home2.css';
import { useNavigate } from "react-router-dom";
import logo from '../Images/Logo_Invis.png';
import yachtVideo from '../Images/yacht.mp4';
import yachtVideo2 from '../Images/Home Page.mp4';
import Footer from '../Components/Footer/Footer';
import Navbar from '../Components/Navbar/Navbar';
import { servicesData } from '../Services/serviceData';
import { getServicesInDisplayOrder } from '../Services/serviceData';
import HomeVid from '../Images/UpdatedLandingPageVid.mp4';


function Home2() {
  // const [menuOpen, setMenuOpen] = useState(false);
 

  // useEffect(() => {
  //   const onResize = () => { if (window.innerWidth > 768) setMenuOpen(false); };
  //   window.addEventListener('resize', onResize);
  //   return () => window.removeEventListener('resize', onResize);
  // }, []);
  // const onNavClick = (e) => {
  //     const a = e.target.closest('a');
  //     if (a) setMenuOpen(false);
  //   };
  const navigate = useNavigate();
  const cardsRef = useRef(null);
  // const homepageServices = servicesData.filter((service) => !service.hideFromGrid);
  const homepageServices = getServicesInDisplayOrder().filter((service) => !service.hideFromGrid);
  const serviceRows = [
    homepageServices.slice(0, 3),
    homepageServices.slice(3, 6),
    homepageServices.slice(6, 7),
  ].filter((row) => row.length > 0);

  useEffect(() => {
    const cardRoot = cardsRef.current;
    if (!cardRoot) return undefined;

    const cards = Array.from(cardRoot.querySelectorAll('.Home2-card'));
    const mobileQuery = window.matchMedia('(max-width: 768px)');

    const revealCardsOnScreen = () => {
      if (!mobileQuery.matches) return;

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
          card.classList.add('is-visible');
        }
      });
    };

    const syncCards = () => {
      if (mobileQuery.matches) {
        revealCardsOnScreen();
        window.addEventListener('scroll', revealCardsOnScreen, { passive: true });
        window.addEventListener('resize', revealCardsOnScreen);
      } else {
        cards.forEach((card) => {
          card.classList.remove('is-visible');
        });
        window.removeEventListener('scroll', revealCardsOnScreen);
        window.removeEventListener('resize', revealCardsOnScreen);
      }
    };

    syncCards();
    mobileQuery.addEventListener('change', syncCards);

    return () => {
      mobileQuery.removeEventListener('change', syncCards);
      window.removeEventListener('scroll', revealCardsOnScreen);
      window.removeEventListener('resize', revealCardsOnScreen);
    };
  }, []);

  return (
    
    <div className="Home2-container">
      {/* Fullscreen Video Background */}
      <div className="Home2-video-container">
        <video autoPlay loop muted className="Home2-video-background">
          <source src={HomeVid} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="Home2-slideshow-overlay"></div>
      </div>

      {/* Hero Section with Logo and Navbar */}
      <div className="Home2-hero">
        {/* <div className="Home2-logo-wrapper">
          <img src={logo} alt="Captain’s Connections Logo" className="Home2-logo" />
        </div> */}

        {/* <button
          className="Home2-menu-toggle"
          aria-expanded={menuOpen}
          aria-controls="home2-links"
          onClick={() => setMenuOpen(v => !v)}
        >
          ☰
        </button> */}

        {/* <nav className="Home2-navbar">
          <div
            id="home2-links"
            className={`Home2-links ${menuOpen ? 'active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            <a href="/services">Our Services In Antigua</a>
            <a href="/destinations">Destinations & Itineraries</a>
            <a href="/connect">Connect With Other Services Across The Caribbean</a>
            <a href="/contact">
              <button className="Home2-contact-button">Contact</button>
            </a>
          </div>
        </nav> */}
      <Navbar/>

      </div>

      {/* Misson Statement */}
      
      <div className="Home2-Mission-statement-section">
        <div className="Home2-Mission-statement">
          {/* <h2>Mission Statement</h2> */}
           <p className='MissonStatement'>"A highly responsive local
Yacht agency offering professional shoreside support and ship agency services in Antigua and across the Caribbean."</p>
          {/*<p>Personalized Services including: </p>
          <li className='MissionStatementList'>
            <ul>Yacht Clearances </ul>
            <ul>Customs & Immigration</ul>
            <ul>Provisioning </ul>
            <ul>Shipping Logistics </ul>
            <ul>Concierge Services & Shore Support.</ul>
          </li> */}
        </div>
      </div>

      {/* Testomonials */}
      <section className='Home2-testimonials'>
        {/* <h2 className='Home2-testimonials-title'>Testimonials</h2> */}
        <div className="Home2-testimonials-grid">
          <div className="Home2-testimonial-card">
            <p className="Home2-testimonial-text">
              “Honest and personal service , and we get really well looked after now in Antigua!” 
            </p>
            <span className="Home2-testimonial-author">
              - Capt. Josh 90ft Swan
            </span>
          </div>

          <div className="Home2-testimonial-card">
            <p className="Home2-testimonial-text">
              "Took care of all of our Antigua logistics....and at times under challenging circumstances - very responsive shoreside support!”
            </p>
            <span className="Home2-testimonial-author">
              - Capt. Matiu Te Hau SY Black Jack 100
            </span>
          </div>

          <div className="Home2-testimonial-card">
            <p className="Home2-testimonial-text">
              “It’s a pleasure to be working with Captain’s Connections, and proof that being on a Caribbean Island doesn’t always need to be complicated for a yacht.”
            </p>
            <span className="Home2-testimonial-author">
              - Capt. Hill SY Hummingbird
            </span>
          </div>
            {/* <div className="Home2-testimonial-card">
            <p className="Home2-testimonial-text">
              “Thanks for your assistance with our haul out and the spare parts too, made it all rather fluid.”
            </p>
            <span className="Home2-testimonial-author">
              
            </span>
          </div> */}
        </div>
      </section>




      {/* Service cards use the same content as the Services and detail pages. */}
      <div ref={cardsRef}>
        {/* {[homepageServices.slice(0, 3), homepageServices.slice(3, 6)].map((row, rowIndex) => (
          <section className={rowIndex === 0 ? 'Home2-info-section' : 'Home2-info-section-bottom'} key={rowIndex}> */}
        {serviceRows.map((row, rowIndex) => (
          <section
            className={`${rowIndex === 0 ? 'Home2-info-section' : 'Home2-info-section-bottom'}${row.length === 1 ? ' Home2-info-section-single' : ''}`}
            key={rowIndex}
          >
            {row.map((service) => (
              <div
                className="Home2-card"
                key={service.slug}
              >
                <h3 className="Home2-hover-title">{service.name}</h3>
                <p>{service.intro}</p>
                <button className="Home2-card-button" onClick={() => navigate(`/services/${service.slug}`)}>
                  Learn More
                </button>
              </div>
            ))}
          </section>
        ))}
      </div>

      




     

      {/* Footer */}
      <Footer/>
      {/* <footer className="site-footer">
        <div className="footer-nav">
          <a href="/services">Our Services In Antigua</a>
          <a href="/destinations">Destinations & Itinerary</a>
          <a href="/connect">Conenect With Services</a>
        </div>
        <hr />
        <div className="footer-bottom">
          <div className="footer-contact">
            <h4>Get In Touch</h4>
            <p>
              Feel free to <a href="/contact">Contact Us</a>.
            </p>
          </div>
          <a href='/'>
            <img src={logo} alt="Captain’s Connections Logo" className="footer-logo-image" />
          </a>
        </div>
      </footer> */}
      
    </div>
  );
}

export default Home2;
